module.exports = __webpack_public_path__ + "media/icons/donation-f43492cf.svg";